export const FilmGrain = () => (
  <>
    <div className="film-grain" aria-hidden="true" />
    <div className="cinematic-vignette" aria-hidden="true" />
  </>
);
